import { P2 } from '@repo/ui/components/Typography';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const Wrapper = styled.div`
  font-style: italic;
  font-size: ${themeStyle.fontSize18};
  line-height: 29px;
  font-weight: ${themeStyle.fontMedium};
  color: ${themeStyle.varInkMain};

  border-left: 2px solid ${themeStyle.varBrandMedium};
  padding: 12px 0 12px 26px;

  p {
    display: inline;
    margin: 0;
  }

  margin-bottom: 24px;
`;

export const Author = styled(P2)`
  font-weight: ${themeStyle.fontBold};
  font-style: normal;
  padding-top: 14px;
`;
